module.exports = __webpack_public_path__ + "static/media/post.8b31d224.svg";